import React, { useState, useEffect } from "react";
import { Col, Tooltip } from "reactstrap";
import "../../../styles/estilos.css";
import { apiGet } from "../../../api";
import { urlCoberturaAigMed } from "../../../constants/urls";
import { useSelector } from "react-redux";

const AccPersonalTooltip = props => {
    const { prima, id, count } = props;
    const [tooltipOpen, setTooltipOpen] = useState(false);

    const toggle = () => setTooltipOpen(!tooltipOpen);
    const name = useSelector(state =>
        state.datosRecuperarCarritoAccP.recuperarCarritoAccP.carProductos[0] && state.datosRecuperarCarritoAccP.recuperarCarritoAccP.carProductos[0].plan ? state.datosRecuperarCarritoAccP.recuperarCarritoAccP.carProductos[0].plan.name :''
    );
    
    useEffect(() => {
        if (name != 'AIGMED') return;

        apiGet(`${urlCoberturaAigMed}&codigo=${prima.codOpcion}`)
        .then( res => prima['coberturas'] = res.coberturas )      
    }, [])

    return (
        <Col
            key={id}
            lg={count < 4 ? 2 : 0}
            md={count < 4 ? 3 : 0}
            sm={count < 4 ? 3 : 0}
            xs={count < 4 ? 3 : 0}
            className="div-align-center"
        >
            <div
                id={"divTituloCobertura-" + id}
                style={
                    count < 4
                        ? {
                            backgroundColor:
                                "rgb(0, 115, 174)",
                        }
                        : {
                            backgroundColor:
                                "rgb(0, 115, 174)",
                            wordBreak: 'break-all'
                        }
                }
            >
                <h2
                    style={
                        count < 4
                            ? {
                                fontSize: 'medium',
                                color: "white",
                                textAlign: "center",
                                textTransform: "uppercase",
                                padding: "10px 10px",
                            }
                            : {
                                fontSize: "x-small",
                                color: "white",

                                textAlign: "center",
                                textTransform: "uppercase",
                                padding: "10px 10px",
                            }
                    }
                >
                    {prima.nomOpcion}
                </h2>
                {name == 'AIGMED' && <Tooltip                    
                    placement="bottom"
                    target={"divTituloCobertura-" + id}
                    isOpen={tooltipOpen}                    
                    toggle={toggle}>                
                    {prima['coberturas'] !== undefined &&
                        prima['coberturas'].map( (cob, i) => {
                            return <p key={i}>{cob}</p>
                        })
                    }                    
                </Tooltip>}
            </div>
        </Col>
    );
};

export default AccPersonalTooltip;